"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertedMypageTripPlanWidgetDataSchema = exports.MypageTripPlanWidgetDataSchema = void 0;
var zod_1 = require("zod");
var MypageTripPlanItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string(),
    badge: zod_1.z.object({ type: zod_1.z.enum(['D_DAY']), title: zod_1.z.string() }),
    image: zod_1.z.object({ url: zod_1.z.string() }),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullable(),
});
exports.MypageTripPlanWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string().optional(),
        action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }).optional(),
    }),
    items: zod_1.z.array(MypageTripPlanItemSchema),
});
var ConvertedMypageTripPlanItemSchema = zod_1.z.object({
    title: zod_1.z.string(),
    subtitle: zod_1.z.string(),
    badge: zod_1.z.string(),
    image: zod_1.z.string(),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional().nullable(),
});
exports.ConvertedMypageTripPlanWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string(),
        action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }).optional(),
    }),
    items: zod_1.z.array(ConvertedMypageTripPlanItemSchema),
});
